<ng-template [ngIf]="aidaEligibility$ | async" let-aidaEligibility>
  <div
    class="d-flex justify-content-between align-items-center p-3 border main-container mb-4"
    [ngClass]="{
      disabled: !aidaEligibility.eligible,
      'pb-0': shouldShowQuotaSelection() && aidaEligibility.eligible
    }"
    [formGroup]="form"
  >
    <div class="d-flex align-items-start gap-2 logo-header">
      <div>
        <div class="d-flex align-items-center">
          <img
            class="stars-img"
            src="./../../../../assets/image/{{
              aidaEligibility.eligible ? 'blue' : 'gray'
            }}-stars.svg"
            alt="stars"
          />
          <p class="mb-0 header-text me-1">AIDA&#8482;</p>
          <span> (AI Delivery Assistant) </span>
          <ps-ui-aida-info-tooltip class="mx-2"></ps-ui-aida-info-tooltip>
        </div>
        <p
          class="text-secondary mb-0"
          *ngIf="isLaunchedSurvey() && !isEnableAidaSurvey"
        >
          AIDA&#8482; can be activated at launch only
        </p>
        <ng-template [ngIf]="aidaEligibility.eligible" [ngIfElse]="notEligible">
          <p
            class="text-secondary mb-0"
            *ngIf="!(isLaunchedSurvey() && !isEnableAidaSurvey)"
          >
            This survey is eligible for our AI Delivery Assistant (AIDA&#8482;),
            to autonomously help field your project.
          </p>
          <div
            *ngIf="shouldShowQuotaSelection()"
            class="d-block p-3 ps-0 pb-0 quota-selection-container"
          >
            <p class="mb-0">
              Please select one (1) quota that you would like AIDA&#8482; to use
              in managing on this project:
            </p>
            <ul class="quota-selection-options list-unstyled">
              <li
                class="ms-3"
                *ngFor="let quota of eligibleAidaQuotasForSelection"
              >
                <label class="me-3" for="qbp-selection-{{ quota.name }}">
                  <input
                    id="qbp-selection-{{ quota.name }}"
                    type="radio"
                    class="form-check-input me-2"
                    name="aidaSelectedQuota"
                    [value]="quota"
                    formControlName="aidaSelectedQuota"
                  />
                  {{ quota.name }}
                </label>
              </li>
            </ul>
          </div>
        </ng-template>

        <ng-template #notEligible>
          <div *ngIf="!(isLaunchedSurvey() && !isEnableAidaSurvey)">
            <p class="text-secondary">
              This project isn't eligible to have AI assist with fielding
            </p>

            <div class="warning d-flex p-3 gap-3 pb-0 ms-2">
              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>

              <div>
                <span>
                  <strong>AIDA&#8482; eligibility requirements:</strong>
                </span>
                <ul>
                  <li *ngFor="let message of aidaEligibility.error_messages">
                    {{ message }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <div
      class="ps-ui-slider-size-lg align-self-start mt-2"
      *ngIf="
        aidaEligibility.eligible && !(isLaunchedSurvey() && !isEnableAidaSurvey)
      "
    >
      <ps-ui-slider
        (selectedChange)="setAidaPayload($event)"
        [selected]="surveyPayload.aida.enabled"
      ></ps-ui-slider>
    </div>
  </div>
</ng-template>
